import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';

// action to be sent to ab-vision to begin recognition

export const START = 'VISION/START';

export interface IStartAction {
  type: typeof START;
}

export const startActionSchema = objectSchemaOf<IStartAction>({
  type: Joi.string().required().valid(START),
});

export const start = actionCreator({
  type: START,
  schema: startActionSchema,
});
